var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.chartData)?_c('v-sheet',{staticClass:"pa-2",attrs:{"rounded":"","color":"#ffffffe0"}},[_c('Bar',{staticStyle:{"height":"220px"},attrs:{"data":_vm.chartData,"options":_vm.chartOptions}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }